import "./contact.css";
import ContactImage from "../../assets/contactImage.webp";
import whatsapp from "../../assets/whatsapp.png";
import instagram from "../../assets/intagram.png";
import tiktok from "../../assets/tiktok.png";
import twitter from "../../assets/twitter.png";
import gmail from "../../assets/gmail.png";
import Avatars from "../../assets/Avatar group.png";
import Button from "../../components/button/Button";
import Accordion from "../../components/accordion/Accordion";
// import { NavLink } from "react-router-dom";
import NavBar from "../../Nav Bar/NavBar";
import LazyLoad from "react-lazyload";
import SEO from "../../components/seo/seo";

const Contact = () => {
  return (
    <>
    <SEO
        title="Contact Us - GiftCard8"
        description="Get in touch with GiftCard8 for inquiries about gift card exchanges. Our team is ready to assist you."
        keywords="GiftCard8, contact GiftCard8, customer service, gift card exchange, support"
        url="https://giftcard8.com/contact-us"
      />
      <NavBar />
      <div className="contact_container">
        <div
          className="container d-flex flex-column justify-content-center align-items-center px-3 px-md-4 px-lg-5 head"
          style={{ margin: "10% 0% 5% 0%" }}
        >
          <h1
            className="text-center fw-bold my-4"
            style={{
              fontSize: "2rem", // Base size for small screens
              fontSize: "clamp(3.5rem, 5vw, 4rem)", // Responsive size scaling
            }}
          >
            Contact Us
          </h1>
          <p className="text-center fs-6 fs-md-5 px-2 px-md-3">
            At GiftCard8, we take customer service as seriously as we do gift
            card exchanges. <br /> When you need us, we are here to help.
          </p>
        </div>
      </div>
      <div
        className="container"
        style={{ marginTop: "7%", marginBottom: "4%" }}
      >
        <div className="d-flex justify-content-center text-center">
          <p className="w-75 fs-5 fs-md-5 fs-sm-6 fs-lg-5 pg">
            We highly value your inquiries and take pride in our fast,
            professional customer service. Please choose from the following
            methods to contact us.
          </p>
        </div>
        <hr style={{ marginTop: "3%", border: "2px solid #777" }} />
      </div>
      <div className="container contact_section position-relative">
        <div className="row mx-2">
          {/* Left Section with Contact Info */}
          <div className="col-lg-6 col-md-6 my-4 textSection1">
            <h5>For urgent inquiries,</h5>
            <h2 className="fw-bold">Call (+86) 19198157166</h2>
            <div className="">
              {/* Flex Container for Social Icons */}
              <div
                className="d-flex justify-content-left align-items-center flex-wrap mt-4"
                style={{
                  gap: "15px", // Add space between icons // Space around the icons
                }}
              >
                {/* WhatsApp Icon */}
                <a
                  href="https://api.whatsapp.com/send/?phone=8619198157166&text&type=phone_number&app_absent=0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex justify-content-center align-items-center"
                  alt="whatsapp"
                  style={{
                    width: "50px", // Set a fixed size for icons
                    height: "50px",
                  }}
                >
                  <img
                    className="social_icon img-fluid p-2 hover-effect"
                    src={whatsapp}
                    alt="whatsapp"
                    style={{
                      width: "100%", // Make sure the icon fills its container
                      height: "100%", // Maintain aspect ratio
                      objectFit: "cover", // Prevent image distortion
                    }}
                  />
                </a>

                {/* Instagram Icon */}
                <a
                  href="https://www.instagram.com/_giftcard8/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex justify-content-center align-items-center"
                  alt="instagram"
                  style={{
                    width: "50px",
                    height: "50px",
                  }}
                >
                  <img
                    className="social_icon p-2 img-fluid hover-effect"
                    src={instagram}
                    alt="instagram"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </a>

                {/* TikTok Icon */}
                <a
                  href="https://www.tiktok.com/@giftcard8app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex justify-content-center align-items-center"
                  alt="tiktok"
                  style={{
                    width: "50px",
                    height: "50px",
                  }}
                >
                  <img
                    className="social_icon p-2 img-fluid hover-effect"
                    src={tiktok}
                    alt="tiktok"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </a>

                {/* Twitter Icon */}
                <a
                  href="https://x.com/Giftcard_8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex justify-content-center align-items-center"
                  alt="twitter"
                  style={{
                    width: "50px",
                    height: "50px",
                  }}
                >
                  <img
                    className="social_icon p-2 img-fluid hover-effect"
                    src={twitter}
                    alt="twitter"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </a>

                {/* Gmail Icon */}
                <a
                  href="mailto:gcard8business@giftcard8.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex justify-content-center align-items-center"
                  alt="gmail"
                  style={{
                    width: "50px",
                    height: "50px",
                  }}
                >
                  <img
                    className="social_icon p-2 img-fluid hover-effect"
                    src={gmail}
                    alt="gmail"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </a>
              </div>
            </div>
          </div>

          {/* Right Section with Image */}
          <div className="col-lg-6 col-md-6">
            <LazyLoad>
              <img
                src={ContactImage}
                className="position-absolute bottom-0 end-0 contact_img"
                alt="Contact"
              />
            </LazyLoad>
          </div>
        </div>
      </div>
      <div className="container">
        <hr style={{ marginTop: "3%", border: "2px solid #777" }} />
      </div>

      <div>
        <div className="container d-flex flex-column justify-content-center align-items-center my-5">
          <h1 className="fw-bold text-center">Frequently asked questions</h1>
          <p style={{ color: "#5D5D5D" }} className="text-center">
            Everything you need to know about GiftCard8
          </p>
        </div>
        <Accordion />
      </div>

      <div
        className="container-fluid"
        style={{ background: "#EEFDFD", padding: "6% 0%" }}
      >
        <div className="container d-flex flex-column justify-content-center align-items-center">
          <img src={Avatars} alt="avaters" className="mt-5 hover-effect" />
          <h1 className="fw-bold fs-1 my-3 text-center">
            Still have questions?
          </h1>
          <p style={{ color: "#5D5D5D" }} className="text-center">
            Can’t find the answer you’re looking for? Please chat with our
            support team.
          </p>
          <div className="w-100 mb-5">
            <a
              className="w-100 d-flex justify-content-center align-items-center"
              style={{ textDecoration: "none" }}
            >
              <Button
                className="w-25 responsive-button hover-effect contBtn"
                style={{
                  background: "transparent",
                  border: "1px solid #5D5D5D",
                  color: "#000",
                }}
                onClick={() => {
                  if (window.Intercom) {
                    window.Intercom("show");
                  } else {
                    console.warn("Intercom is not loaded");
                  }
                }}
              >
                Contact us Online
              </Button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
